import { channels } from "@/mocks/home";

export default function SubmitChannels() {
  return (
    <section id="submit" className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs md:text-sm font-medium tracking-wide text-primary-600">
              投稿入口
            </span>
            <h3 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              两种方式，任选其一完成匿名投稿
            </h3>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            不需要注册账号，也不需要填写真实姓名。挑一个你觉得顺手的方式，把线索交给社区即可。
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {channels.map((channel) => (
            <article
              key={channel.id}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-7 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between gap-4">
                <span className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className={`${channel.icon} text-2xl text-primary-700`}></i>
                </span>
                <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium whitespace-nowrap">
                  {channel.tag}
                </span>
              </div>

              <h4 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-950">
                {channel.title}
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{channel.desc}</p>

              <ul className="mt-5 space-y-2.5">
                {channel.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line text-base text-secondary-600 mt-0.5 shrink-0"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 pt-5 border-t border-background-200 flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  className="flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-arrow-right-up-line"></i>
                  <span>{channel.action}</span>
                </button>
                <span className="text-xs text-foreground-500 break-all">{channel.note}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}